import React from "react";
import {
  MDBContainer,
  MDBMask,
  MDBView,
  MDBFooter,
  MDBAnimation,
} from "mdbreact";
import "./style.css";
import Copyrights from "../../components/footer";
import ContactUs from "./contact";
import { TopLogin as Login } from "../../components/auth";
import Description from "./description";
import Pioneers from "./pioneers";
import LOGO from "./../../assets/iMD.png";
import Testimonials from "./testimonials";
import AboutUs from "./aboutUs";
import Gallery from "./gallery";
import SlideShow from "./slideShow";
import { Helmet } from "react-helmet";
import Affiliates from "./affiliates";
import ECGWave from "./../subscribers/diagnostics/cardioGraph";
export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseID: "",
      show: false,
      scrolled: false,
      flipped: false,
      menuOpen: false,
      buttonOpen: false,
      connectOpen: false,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const isScrolled = window.scrollY > 50;
    if (isScrolled !== this.state.scrolled) {
      this.setState({ scrolled: isScrolled });
    }
  };

  scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // After a successful sign-up: back to the slides, with the login open.
  handleRegistered = () => this.setState({ flipped: false, show: true });

  handleFlip = () => {
    this.setState({ flipped: !this.state.flipped });
  };

  toggle = () => this.setState({ show: !this.state.show });

  toggleCollapse = (collapseID) => () =>
    this.setState((prevState) => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : "",
    }));

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuOpen: !prevState.menuOpen,
    }));
  };

  toggleButtons = () => {
    this.setState((prevState) => ({ buttonOpen: !prevState.buttonOpen }));
  };

  toggleConnect = () => {
    this.setState((prevState) => ({
      connectOpen: !prevState.connectOpen,
    }));
  };

  render() {
    return (
      <div id="landing" className="overflow-hidden">
        <Helmet>
          <title>
            Pinoy iMD - Filipino EHR, HIMS & Medical Diagnostics Software
          </title>
          <meta
            name="description"
            content="Pinoy iMD is a Filipino-developed EHR, LIS, and clinic management system designed for diagnostic laboratories, mobile clinics, and healthcare providers in the Philippines."
          />
          <meta
            name="keywords"
            content="EHR Philippines, LIS software, Filipino clinic system, medical diagnostics, hospital information management system, Pinoy iMD, DOH compliant LIS"
          />
          <meta name="robots" content="index, follow" />
          <meta
            name="google-site-verification"
            content="google8a375c824ecf58f7"
          />
        </Helmet>

        <MDBAnimation
          reveal
          type="fadeInDown"
          duration="1.5s"
          delay="500ms"
          className="homePage-topbar"
        >
          <div
            className={`homePage-topbar-animation ${
              this.state.scrolled ? "scrolled" : ""
            }`}
          ></div>
          <div className="homePage-topbar-left">
            <div
              className={`homePage-logo ${
                this.state.scrolled ? "scrolled" : ""
              }`}
            >
              <img src={LOGO} alt="logo" />
              Pinoy iMD
            </div>
            <div
              className={`homePage-menu ${
                this.state.menuOpen ? "homePage-open" : ""
              } ${this.state.scrolled ? "scrolled" : ""}`}
            >
              <a
                href="#home"
                onClick={(e) => {
                  e.preventDefault();
                  this.scrollToSection("home");
                }}
              >
                Home
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  this.scrollToSection("features");
                }}
              >
                Features
              </a>
              <a
                href="#pioneers"
                onClick={(e) => {
                  e.preventDefault();
                  this.scrollToSection("pioneers");
                }}
              >
                Pioneers
              </a>
              <a
                href="#testimonials"
                onClick={(e) => {
                  e.preventDefault();
                  this.scrollToSection("testimonials");
                }}
              >
                Testimonials
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  this.scrollToSection("contact");
                }}
              >
                Contact Us
              </a>
            </div>
          </div>

          <div className="homePage-topbar-right">
            {/* Desktop Buttons */}
            <div className="homePage-desktop-buttons">
              <button
                className={`homePage-btn-login ${
                  this.state.scrolled ? "scrolled" : ""
                }`}
                onClick={this.toggle}
              >
                Login
              </button>
              <button
                className={`homePage-btn-signup ${
                  this.state.scrolled ? "scrolled" : ""
                }`}
                onClick={this.handleFlip}
              >
                Sign Up
              </button>
            </div>

            {/* Hamburger for mobile */}
            <div
              className={`homePage-hamburger  ${
                this.state.menuOpen ? "homePage-active" : ""
              }`}
              onClick={this.toggleMenu}
            >
              <div
                className={`homePage-bar ${
                  this.state.scrolled ? "scrolled" : ""
                }`}
              ></div>
              <div
                className={`homePage-bar ${
                  this.state.scrolled ? "scrolled" : ""
                }`}
              ></div>
              <div
                className={`homePage-bar ${
                  this.state.scrolled ? "scrolled" : ""
                }`}
              ></div>
            </div>

            {/* Mobile Connect Button */}
            <div className="homePage-mobile-connect">
              <button
                className={`homePage-btn-connect ${
                  this.state.connectOpen ? "activeConnect" : ""
                } ${this.state.scrolled ? "scrolled" : ""}`}
                onClick={this.toggleConnect}
              >
                Connect ▾
              </button>

              <div
                className={`homePage-connect-dropdown ${
                  this.state.connectOpen ? "activeConnect" : ""
                }`}
              >
                <button
                  className="homePage-btn-login-dropdown"
                  onClick={this.toggle}
                >
                  Login
                </button>
                <button
                  className="homePage-btn-signup-dropdown"
                  onClick={this.handleFlip}
                >
                  Sign Up
                </button>
              </div>
            </div>
          </div>
        </MDBAnimation>
        <div
          className={`homePage-overlay ${this.state.menuOpen ? "active" : ""}`}
          onClick={() => {
            this.setState({ menuOpen: false });
          }}
        ></div>

        <section id="home">
          <Login
            show={this.state.show}
            toggle={this.toggle}
            allowSignup
          />
          <MDBView>
            <MDBMask
              className="d-flex justify-content-center align-items-center"
              overlay="gradient"
            >
              <div className="homePage-container" id="home-content">
                <SlideShow
                  handleFlip={this.handleFlip}
                  flipped={this.state.flipped}
                  onRegistered={this.handleRegistered}
                />
              </div>
            </MDBMask>
          </MDBView>
        </section>
        <MDBContainer
          fluid
          style={{ backgroundColor: "#00796B1A" }}
          className="p-0"
        >
          <div id="intro">
            <Description />
          </div>
          <ECGWave color="#00B8D4" waves={10} className="my-4" />
          <div id="features">
            <AboutUs />
          </div>
          <ECGWave color="#00B8D4" waves={19} className="my-4" />

          <div id="affiliates">
            <Affiliates />
          </div>

          <ECGWave color="#00B8D4" waves={10} className="my-4" />

          <div id="testimonials">
            <Testimonials />
          </div>

          <ECGWave color="#00B8D4" waves={25} className="my-4" />

          <div id="pioneers">
            <Pioneers />
          </div>
          <ECGWave color="#00B8D4" waves={19} className="my-4" />

          <div id="gallery">
            <Gallery />
          </div>
          <ECGWave color="#00B8D4" waves={5} className="my-4" />

          <div id="contact">
            <ContactUs />
          </div>
        </MDBContainer>
        <MDBFooter className="text-center text-md-left">
          <Copyrights
            backgroundColor="#00564B"
            borderColor="#004B42 "
            fbLink="https://web.facebook.com/profile.php?id=61579153924730#"
          />
        </MDBFooter>
      </div>
    );
  }
}
